import {
  DraftQuestionnaireEntry,
  EntryType
} from '../../../../data/model/questionnaire'
import { truncateText } from '../../../../utils/questionnaireUtils'
import { ResponseOptionsByQuestion } from '../../Questionnaire.slice'

export const getResponseOptionValue: (options: {
  entryType: Exclude<EntryType, EntryType.MatrixEntryType> | undefined
  entryItemLk: string | undefined
  maskedItemLk: string | undefined
  responseOptionsByQuestion: ResponseOptionsByQuestion
}) => string | undefined = ({
  entryType,
  entryItemLk,
  maskedItemLk,
  responseOptionsByQuestion
}) => {
  let text = ''
  if (entryType === EntryType.QuestionEntryType) {
    const responseOption = entryItemLk
      ? // @todo Legacy eslint violation – fix this when editing
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        responseOptionsByQuestion[entryItemLk]?.find(
          (ro) => ro.responseOptionLk === maskedItemLk
        )?.responseOption
      : null
    text = responseOption?.value ?? ''
  }

  return truncateText(70, text)
}

const getMaskedItems = (
  entry: DraftQuestionnaireEntry,
  maskedItemLk: string | undefined
): { hiddenInMarkets?: string[] | null }[] => {
  switch (entry.entryType) {
    case EntryType.QuestionEntryType:
      return entry.entryItem.responseOptions.filter(
        (ro) => ro.responseOptionLk === maskedItemLk
      )
    case EntryType.MatrixEntryType:
      return [
        ...entry.entryItem.matrixRows.filter(
          (row) => row.questionLk === maskedItemLk
        ),
        ...entry.entryItem.responseOptions.filter(
          (ro) => ro.responseOptionLk === maskedItemLk
        )
      ]
    default:
      return []
  }
}

/** The markets a masked option or matrix row is hidden in, its question's included. */
export const getMaskedItemHiddenInMarkets = ({
  entryType,
  entryItemLk,
  maskedItemLk,
  entries
}: {
  entryType: EntryType | undefined
  entryItemLk: string | undefined
  maskedItemLk: string | undefined
  entries: DraftQuestionnaireEntry[]
}): string[] => {
  const entry = entries.find(
    (candidate) =>
      (entryType === EntryType.QuestionEntryType &&
        candidate.entryType === EntryType.QuestionEntryType &&
        candidate.entryItem.questionLk === entryItemLk) ||
      (entryType === EntryType.MatrixEntryType &&
        candidate.entryType === EntryType.MatrixEntryType &&
        candidate.entryItem.matrixTitleLk === entryItemLk)
  )
  return entry
    ? [
        ...(entry.hiddenInMarkets ?? []),
        ...getMaskedItems(entry, maskedItemLk).flatMap(
          (item) => item.hiddenInMarkets ?? []
        )
      ]
    : []
}
